import * as SentryReact from "@sentry/react";
import * as SentryCapacitor from "@sentry/capacitor";
import { makeMultiplexedTransport } from "@sentry/core";

import { DSN_ANDROID, DSN_WEB } from "../constants/sentry";
import { getCurrentAppPlatform, isNativeApp, isTV } from "../utils/platform";
import { getDeviceInfo } from "../utils/deviceDetection";

export const configureSentry = () => {
  const device = getDeviceInfo();
  const kcConfig = JSON.parse(import.meta.env.VITE_KC_AUTH_CONFIG || "{}");

  const options = {
    dsn: isNativeApp ? DSN_ANDROID : DSN_WEB,
    ...(isNativeApp
      ? {
          transport: makeMultiplexedTransport(
            SentryReact.makeFetchTransport,
            () => [DSN_WEB],
          ),
        }
      : {}),
    release: import.meta.env.VITE_BUILD_VERSION,
    environment: kcConfig.realm,
    integrations: [
      SentryReact.browserTracingIntegration(),
      ...(isTV ? [] : [SentryReact.replayIntegration()]),
    ],
    // Native runs through the Capacitor bridge — keep traces low to reduce bridge overhead
    tracesSampleRate: isNativeApp ? 0.2 : 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    enabled: kcConfig.realm !== "dev",
    initialScope: {
      tags: {
        platform: getCurrentAppPlatform(),
        isTV,
        isNativeApp,
        device_vendor: device.make || "unknown",
        device_model: device.model || "unknown",
        device_os: device.os || "unknown",
        resolution: String(device.resolution),
        device_type: device.type,
      },
      contexts: {
        device: {
          ...device,
          userAgent: navigator.userAgent,
          pixelRatio: window.devicePixelRatio,
        },
      },
    },
  };

  if (isNativeApp) {
    SentryCapacitor.init(options, SentryReact.init);
  } else {
    SentryReact.init(options);
  }
};
